import {EventParticipant} from "./EventParticipant";


export class ConnectionRequest {

  public profile: EventParticipant;

  constructor(public subjectId: string,
              public timestamp: number) {

  }

  static fromAngularFireSnapshots(snapshots: any) : ConnectionRequest[] {
    return snapshots.map(snap => ConnectionRequest._fromSnapshot(snap.key, snap.payload.val()));
  }

  private static _fromSnapshot(key: string, data) {
    return new ConnectionRequest(key, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/communication/models/ConnectionRequest.ts